import {parseResponse} from "../api"

export default class InvoiceService {
  constructor(axios) {
    // todo(egor): add config for domain
    this.axios = axios
  }

  async reCalculateCaseAnomalies({caseId}) {
    return this.axios.post('/api/case-anomalies-re-calculate-case-anomalies', {
      caseId
    }).then((response) => {
      return parseResponse(response)
    })
  }

  async reCalculateAllCasesAnomalies() {
    return this.axios.post('/api/case-anomalies-re-calculate-all-cases-anomalies', {
    }).then((response) => {
      return parseResponse(response)
    })
  }
}




// WEBPACK FOOTER //
// ./src/services/CaseAnomaliesService.js